import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE_KEY } from './shared/constants';

i18n.use(Backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: DEFAULT_LANGUAGE_KEY,
        debug: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export { i18n };
